import { View, ViewState } from "../View";

interface Q3State extends ViewState {
    fieldContent: string
}

export default class Q3_1 extends View<Q3State> {
    render() {
        return (
            <div className="Q3_1">
                <h2>Quel âge avez-vous ?</h2>
                <hr />
                <div className="btn-group">
                    <input type="number" min="1" max="100" onChange={e => this.setState({fieldContent: e.target.value})} />
                    <button onClick={ () => this.props.onFinish(this.state.fieldContent) }>Valider</button>
                </div>
            </div>
        );
    }
}
